import { useState, useCallback } from 'react'
import { toastError, toastSuccess, toastLoading, toastDismiss } from '../utils/toastHelper'

import { ApiClient } from '../services/api'

interface QRValidationResponse {
  valid: boolean
  message: string
  reserva_id?: string
  cliente_nombre?: string
  espacio_nombre?: string
  fecha_entrada?: string
  fecha_salida?: string
}

export const useQRScanner = () => {
  const [isValidating, setIsValidating] = useState(false)
  const [validationResult, setValidationResult] = useState<QRValidationResponse | null>(null)

  const validateQR = useCallback(async (qrData: string) => {
    setIsValidating(true)
    setValidationResult(null)

    try {
      // Enviar QR al backend para validación
      const response = await ApiClient.post<QRValidationResponse>(
        '/api/qr/validate',
        { qr_data: qrData }
      )

      // El ApiClient ya desenvuelve automáticamente la respuesta wrapper
      const validationData = response as QRValidationResponse

      setValidationResult(validationData)

      return validationData
    } catch (error) {
      const errorMsg = error instanceof Error ? error.message : 'Error desconocido'
      const result: QRValidationResponse = {
        valid: false,
        message: `❌ Error al procesar QR: ${errorMsg}`,
      }
      setValidationResult(result)
      return result
    } finally {
      setIsValidating(false)
    }
  }, [])

  const clearResult = useCallback(() => {
    setValidationResult(null)
  }, [])

  return {
    isValidating,
    validationResult,
    validateQR,
    clearResult,
  }
}
